import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { value: "" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_20 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = { value: "" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_40 = { class: "col-lg-8 fv-row" }
const _hoisted_41 = { value: "" }
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_47 = { class: "col-lg-8 fv-row" }
const _hoisted_48 = { value: "" }
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "row mb-6" }
const _hoisted_51 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_52 = { class: "col-lg-8 fv-row" }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_55 = { class: "col-lg-8 fv-row" }
const _hoisted_56 = { class: "row mb-6" }
const _hoisted_57 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_58 = { class: "col-lg-8 fv-row" }
const _hoisted_59 = { class: "fv-plugins-message-container" }
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { class: "row mb-6" }
const _hoisted_62 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_63 = { class: "col-lg-8 fv-row" }
const _hoisted_64 = { class: "fv-plugins-message-container" }
const _hoisted_65 = { class: "fv-help-block" }
const _hoisted_66 = { class: "row mb-6" }
const _hoisted_67 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_68 = { class: "col-lg-8 fv-row" }
const _hoisted_69 = { class: "row mb-6" }
const _hoisted_70 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_71 = { class: "col-lg-8 fv-row" }
const _hoisted_72 = { class: "fv-plugins-message-container" }
const _hoisted_73 = { class: "fv-help-block" }
const _hoisted_74 = { class: "form-text" }
const _hoisted_75 = { class: "row mb-6" }
const _hoisted_76 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_77 = { class: "col-lg-8 fv-row" }
const _hoisted_78 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_79 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_80 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_81 = { class: "indicator-label" }
const _hoisted_82 = { class: "indicator-progress" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewValidationRule')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('name')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "name",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('Rule Name')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "name" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('Rule Type')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "ruleType",
                      class: "form-select form-select-lg form-select-solid",
                      modelValue: _ctx.selectedRuleType,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRuleType) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.translate('Select Rule Type')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleTypes, (ruleType) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: ruleType.id,
                            value: ruleType.id
                          }, _toDisplayString(ruleType.name), 9, _hoisted_16))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_ErrorMessage, { name: "ruleType" })
                      ])
                    ])
                  ])
                ]),
                (_ctx.selectedRuleType === 'CLASS_CATEGORY')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.translate('Class Category')), 1),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_Field, {
                          as: "select",
                          name: "classCategoryId",
                          class: "form-select form-select-lg form-select-solid"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.translate('Select Class Category')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allClassCategories, (category) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: category.id,
                                value: category.id
                              }, _toDisplayString(category.nameEn), 9, _hoisted_23))
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_ErrorMessage, { name: "classCategoryId" })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.selectedRuleType === 'PACKAGE_COUNT' ||
              _ctx.selectedRuleType === 'INVALID_PACKAGE'
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('Package Count Min')), 1),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_Field, {
                            type: "number",
                            name: "packageCountMin",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('Minimum Package Count')
                          }, null, 8, ["placeholder"]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_ErrorMessage, { name: "packageCountMin" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('Package Count Max')), 1),
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_Field, {
                            type: "number",
                            name: "packageCountMax",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('Maximum Package Count')
                          }, null, 8, ["placeholder"]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_ErrorMessage, { name: "packageCountMax" })
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedRuleType === 'HORSE_LESSON_COMBO')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.translate('Horse Type')), 1),
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: "horseTypeId",
                            class: "form-select form-select-lg form-select-solid"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_41, _toDisplayString(_ctx.translate('Select Horse Type')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.horseTypes, (horseType) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: horseType.id,
                                  value: horseType.id
                                }, _toDisplayString(horseType.name), 9, _hoisted_42))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_ErrorMessage, { name: "horseTypeId" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.translate('Lesson Type')) + " (" + _toDisplayString(_ctx.translate('Optional')) + ") ", 1),
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: "lessonTypeId",
                            class: "form-select form-select-lg form-select-solid"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.translate('Select Lesson Type')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lessonTypes, (lessonType) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: lessonType.id,
                                  value: lessonType.id
                                }, _toDisplayString(lessonType.name), 9, _hoisted_49))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.translate('Package Count Min')), 1),
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_Field, {
                            type: "number",
                            name: "packageCountMin",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('Minimum Package Count')
                          }, null, 8, ["placeholder"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.translate('Package Count Max')), 1),
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_Field, {
                            type: "number",
                            name: "packageCountMax",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('Maximum Package Count')
                          }, null, 8, ["placeholder"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.translate('Number Of Cancellation')), 1),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "numberOfCancellation",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('Max Cancellations')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_ErrorMessage, { name: "numberOfCancellation" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.translate('Number Of Days')), 1),
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "numberOfDays",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('Max Days')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_ErrorMessage, { name: "numberOfDays" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.translate('Number Of Days Error')), 1),
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "numberOfDaysError",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('Error Message')
                    }, null, 8, ["placeholder"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.translate('Priority')), 1),
                  _createElementVNode("div", _hoisted_71, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "priority",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('Rule Priority')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createVNode(_component_ErrorMessage, { name: "priority" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.translate('Lower number = higher priority')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.translate('Is Active')), 1),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        name: "isActive",
                        class: "form-check-input",
                        value: "true",
                        checked: true
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_80, [
                  _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_82, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_83
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}